module.exports = __webpack_public_path__ + "public/img/yibiaopan_lv_17.7daf7296.png";